import { ServerRoutes } from "@rinastyling/common";
import { GetOpenedStore, GetUsersCart } from "@rinastyling/common";
import { ServerService } from "./ServerService";
export class StoreService extends ServerService {
  constructor() {
    super(ServerRoutes.store);
  }

  getOpenedStore() {
    return this.typedFetch<
      GetOpenedStore["request"],
      GetOpenedStore["response"]
    >("get-opened-store");
  }
  getUsersCart() {
    return this.typedFetch<GetUsersCart["request"], GetUsersCart["response"]>(
      "get-users-cart"
    );
  }
}
